<template>
<div>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">
    <div>
      <el-select v-model="settlement_method" size="mini" placeholder="结算方式" filterable remote clearable
                 reserve-keyword :remote-method="getOrderPaymentList" style="width: 100%;">
        <el-option v-for="item in order_payment_list" :key="item.id" :label="item.name" :value="item.number"></el-option>
      </el-select>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitOk">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: "SelectPayment",
  data() {
    return {
      dialogVisible: false,
      settlement_method:"",
      order_payment_list:[],
      callback:null
    };
  },
  methods: {
    show(callback=null){
      const that=this;
      that.dialogVisible=true;
      that.callback=callback;
      that.getOrderPaymentList();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    getOrderPaymentList() {
      const that = this;
      let where = {};
      ERP.getRequest({
        url: "admin/OrderPayment/getList",
        data: {
          where: JSON.stringify(where),
          page: 1,
          page_size: 400
        }
      }, ret => {
        if (ret.code) {
          that.order_payment_list = ret.data.list;
        }
      })
    },
    submitOk(){
      const that = this;
      if(!that.settlement_method){
        that.$message.error("请选择支付方式")
        return false;
      }
      typeof that.callback==="function"&&(that.callback(that.settlement_method));
      that.dialogVisible=false;
      that.callback=null;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/SelectPayment.vue